const widgetName = 'socialNetworkWidgetSecond';
let initialized = false;

function initialize() {

  $(`#socialNetworkWidgetSecond`).append('<div class="socialTabContainer"></div>');
}


function isCurrent(current, widget) {
  if (current) {
    $(`#socialNetworkWidgetSecond #${widget}Tab`).addClass('activeTab');
    $(`#socialNetworkWidgetSecond #${widget}Container`).show();
  }
}


// FACEBOOK -----------
let fbHeight = "0"
let windowSize = window.innerWidth;
let fbkUrl = "https://www.facebook.com/blackhillsstockshow/";

if ($('body').hasClass('saffireMobileSize') || windowSize <= 800) {
  fbHeight = "460" // Value to be changed depending on design
} else {
  fbHeight = "570" // Value to be changed depending on design
}
const fbWidth = 500; // Can be as it is right now
function facebookfeedSecondary(current) {

  const facebookfeedTab = `
          <a id="facebookfeedTab" class="socialNetworkTabSecond activeTab" data-social-network-tab="facebookfeed">
            <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" class="circle" >
              <title>Facebook Tab Icon</title>
              <g id="Facebook_Tab_Icon" data-name="Facebook_Tab_Icon">
                <path d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"/>
            </svg>
          </a>
        `;

  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" >
      <div class="fb-page" data-href="${fbkUrl}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbkUrl}"><a href="${fbkUrl}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;

  isCurrent(current, 'facebookfeed');
  if (!initialized) {
    initialize();
  }

  let title = "Black Hills Stock Show & Rodeo";
  $(`#socialNetworkWidgetSecond .socialTabContainer`).append(facebookfeedTab);
  $(`#socialNetworkWidgetSecond`).append(facebookfeedContainer);
  $(`#socialNetworkWidgetSecond .socialTabContainer`).append(`<h3 class="social-header" aria-label="${title}">${title}</h3>`);
}


export { facebookfeedSecondary };